const statesCaptionEntities = {
  DIARY_EVENT: 'diaryEvent',
  VITAL_SIGN: 'vitalSign',
  NOTIFICATION: 'notification',
  QUESTIONNAIRE: 'questionnaire',
  ACTIVE_STATE: 'activeState',
  REQUEST_TYPE: 'requestType',
  TASKS_TYPES: 'tasksTypes',
  TASKS_STATES: 'tasksStates'
};

export {
  statesCaptionEntities
};

